import { Constants } from "../constants/Contants";
import request from "../utils/useApi";

export const getOrders = async (search) => {
  try {
    const url = search
      ? `${Constants.get_flight_orders_url}?search=${encodeURIComponent(
          search
        )}`
      : Constants.get_flight_orders_url;
    const res = await request.get(url);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};
